import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

type Props = {
  show: boolean;
  onHide: () => void;
};

const SandboxReadOnlyModal: React.FC<Props> = ({ show, onHide }) => {
  const history = useHistory();

  const handleSignUp = () => {
    onHide();
    history.push("/signup");
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem" }}>Read-only demo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: "0.75rem" }}>
          This is a <strong>read-only sandbox</strong>. You can explore DocuClipper with sample data, but uploads, edits, and other changes require a real account.
        </p>
        <p style={{ marginBottom: "1rem", color: "#6c757d", fontSize: "0.9rem" }}>
          Sign up for a free account to process your own documents — bank statements, invoices, W-2s, checks, paystubs, and custom templates.
        </p>
        <div className="d-grid gap-2">
          <Button variant="primary" block onClick={handleSignUp}>
            Sign up free — use your own data
          </Button>
          <Button variant="link" size="sm" onClick={onHide} style={{ color: "#6c757d" }}>
            Keep exploring the demo
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SandboxReadOnlyModal;
